import { AD_STATUS } from './adConsts';
import { CAMPAIGN_STATUS } from './campaignsConsts';
import PERFORMANCE_STATUS from './performanceStatus';
import { STATUS_TYPE, getStatusType } from './statusConsts';

export const CREATIVE_STATUS = {
    RECENT: 'RECENT',
    RUNNING: 'RUNNING',
    PAUSED: 'PAUSED',
    STOPPED: 'STOPPED',
    REJECTED: 'REJECTED',
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    PENDING: 'PENDING',
    NEED_TO_EDIT: 'NEED_TO_EDIT',
    CAMPAIGN_PAUSED: 'CAMPAIGN_PAUSED',
    CAMPAIGN_DEPLETED: 'CAMPAIGN_DEPLETED',
    CAMPAIGN_DEPLETED_CURRENT_MONTH: 'CAMPAIGN_DEPLETED_CURRENT_MONTH',
    CAMPAIGN_TERMINATED: 'CAMPAIGN_TERMINATED',
    CAMPAIGN_EXPIRED: 'CAMPAIGN_EXPIRED',
    CAMPAIGN_DISABLED: 'CAMPAIGN_DISABLED',
    FROZEN: 'FROZEN',
    PENDING_START_DATE: 'PENDING_START_DATE',
    EXPIRED: 'EXPIRED',
    CRAWLING: 'CRAWLING',
    APPROVED: 'APPROVED',
    AD_PAUSED: 'AD_PAUSED',
    AD_REMOVED: 'AD_REMOVED',
};

export const CREATIVE_ORIENTATION = {
    HORIZONTAL: 'HORIZONTAL',
    VERTICAL: 'VERTICAL',
};

export const STATUS = {
    PAUSED: 'PAUSED',
    ACTIVE: 'ACTIVE',
};

export const STATUS_KEYS = Object.keys(STATUS);

export const CREATIVE_ORIENTATION_FILTERS_VALUES = Object.values(CREATIVE_ORIENTATION);

export const CREATIVE_STATUS_FILTERS = {
    RECENT: CREATIVE_STATUS.RECENT,
    PAUSED: CREATIVE_STATUS.PAUSED,
    STOPPED: CREATIVE_STATUS.STOPPED,
    REJECTED: CREATIVE_STATUS.REJECTED,
    PENDING_APPROVAL: CREATIVE_STATUS.PENDING_APPROVAL,
    NEED_TO_EDIT: CREATIVE_STATUS.NEED_TO_EDIT,
    RUNNING: CREATIVE_STATUS.RUNNING,
};
export const APPROVAL_STATUS_FILTERS = {
    PENDING: CREATIVE_STATUS.PENDING,
    APPROVED: CREATIVE_STATUS.APPROVED,
    REJECTED: CREATIVE_STATUS.REJECTED,
};

export const CREATIVE_STATUS_REASONS = {
    DUPLICATE: 'DUPLICATE',
    NO_TITLE: 'NO_TITLE',
    NO_THUMBNAIL: 'NO_THUMBNAIL',
    NO_URL: 'NO_URL',
    TIMEOUT: 'TIMEOUT',
    IMAGE_WITHOUT_LICENSE: 'IMAGE_WITHOUT_LICENSE',
    CUSTOM_RULE: 'CUSTOM_RULE',
};

export const CREATIVE_STATUS_KEYS = Object.values(CREATIVE_STATUS);
export const CREATIVE_STATUS_FILTER_KEYS = Object.values(CREATIVE_STATUS_FILTERS);
export const APPROVAL_STATUS_FILTER_KEYS = Object.values(APPROVAL_STATUS_FILTERS);

const creativeStatusConfig = {
    [CREATIVE_STATUS.APPROVED]: { statusType: STATUS_TYPE.SUCCESS },
    [CREATIVE_STATUS.RUNNING]: { statusType: STATUS_TYPE.SUCCESS },
    [CREATIVE_STATUS.NEED_TO_EDIT]: { statusType: STATUS_TYPE.DANGER },
    [CREATIVE_STATUS.PAUSED]: { statusType: STATUS_TYPE.INFO },
    [CREATIVE_STATUS.PENDING_APPROVAL]: { statusType: STATUS_TYPE.INFO },
    [CREATIVE_STATUS.REJECTED]: { statusType: STATUS_TYPE.DANGER },
    [CREATIVE_STATUS.PENDING_START_DATE]: { statusType: STATUS_TYPE.INFO },
    [CREATIVE_STATUS.EXPIRED]: { statusType: STATUS_TYPE.DANGER },
};

const campaignStatusMap = {
    [CAMPAIGN_STATUS.PAUSED]: CREATIVE_STATUS.CAMPAIGN_PAUSED,
    [CAMPAIGN_STATUS.DEPLETED]: CREATIVE_STATUS.CAMPAIGN_DEPLETED,
    [CAMPAIGN_STATUS.DEPLETED_MONTHLY]: CREATIVE_STATUS.CAMPAIGN_DEPLETED_CURRENT_MONTH,
    [CAMPAIGN_STATUS.TERMINATED]: CREATIVE_STATUS.CAMPAIGN_TERMINATED,
    [CAMPAIGN_STATUS.EXPIRED]: CREATIVE_STATUS.CAMPAIGN_EXPIRED,
    [CAMPAIGN_STATUS.FROZEN]: CREATIVE_STATUS.FROZEN,
    [CAMPAIGN_STATUS.DISABLED]: CREATIVE_STATUS.CAMPAIGN_DISABLED,
};

export const PERFORMANCE_STATUS_FILTERS = {
    MOTION: PERFORMANCE_STATUS.MOTION,
    IMAGE: PERFORMANCE_STATUS.IMAGE,
};

export const PERFORMANCE_STATUS_FILTER_VALUES = Object.values(PERFORMANCE_STATUS_FILTERS);

export const CHANNEL_TYPE = {
    SPONSORED_DISPLAY: 'SPONSORED_DISPLAY',
    SPONSORED_REGULAR: 'SPONSORED_REGULAR',
};

export const CHANNEL_TYPE_FILTERS_VALUES = Object.values(CHANNEL_TYPE);

export const CREATIVE_LIBRARY_FORMAT_TYPE_FILTERS = {
    SPONSORED_CONTENT: 'SPONSORED_CONTENT',
    APP_INSTALL: 'APP_INSTALL',
    THIRD_PARTY_TAG: 'THIRD_PARTY_TAG',
    HOSTED_IMAGE: 'HOSTED_IMAGE',
    HOSTED_HTML: 'HOSTED_HTML',
    HOSTED_SOCIAL: 'HOSTED_SOCIAL',
};
export const FORMAT_TYPE_FILTERS = {
    ...CREATIVE_LIBRARY_FORMAT_TYPE_FILTERS,
    CAROUSEL: 'CAROUSEL',
    ISI: 'ISI',
    HOSTED_VIDEO: 'HOSTED_VIDEO',
};
export const FORMAT_TYPE_FILTERS_VALUES = Object.values(FORMAT_TYPE_FILTERS);

export const CREATIVE_LIBRARY_FORMAT_TYPE_FILTERS_VALUES = Object.values(CREATIVE_LIBRARY_FORMAT_TYPE_FILTERS);

export const getCreativeStatusType = creativeStatus => getStatusType(creativeStatusConfig, creativeStatus);

export const isCreativeStatusRejected = ({ status, rejectReason }) =>
    status === CREATIVE_STATUS.REJECTED && rejectReason;

export const isCreativeStatusNeedToEditWithReason = ({ status, statusReason }) =>
    status === CREATIVE_STATUS.NEED_TO_EDIT && statusReason && CREATIVE_STATUS_REASONS[statusReason];

export const resolveCreativeStatusWithParentCampaignStatus = (itemStatus, data) => {
    const { campaignStatus, statusReason, isCreativeLibrary, adStatus } = data;
    if (itemStatus === CREATIVE_STATUS.PAUSED && statusReason === CREATIVE_STATUS_REASONS.CUSTOM_RULE) {
        return CREATIVE_STATUS.PAUSED;
    }
    if (isCreativeLibrary) {
        if (adStatus === AD_STATUS.ARCHIVED) {
            return CREATIVE_STATUS.AD_REMOVED;
        } else if (adStatus === AD_STATUS.PAUSED) {
            return CREATIVE_STATUS.AD_PAUSED;
        }
    }
    return itemStatus === CREATIVE_STATUS.RUNNING && campaignStatusMap[campaignStatus]
        ? campaignStatusMap[campaignStatus]
        : itemStatus;
};
